"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ItemFilterStyled = require("./ItemFilter-styled.js");
var _Users = _interopRequireDefault(require("../Users"));
var _Folders = _interopRequireDefault(require("../Folders"));
var _Filters = _interopRequireDefault(require("../Filters"));
var _actions = _interopRequireDefault(require("../../store/actions"));
var _stateTypes = _interopRequireDefault(require("../../store/stateTypes"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var ItemFilter = function ItemFilter(_ref) {
  var _portal$user, _portal$user$privileg;
  var itemBrowserState = _ref.itemBrowserState,
    handleStateUpdate = _ref.handleStateUpdate,
    showFolderFilter = _ref.showFolderFilter,
    showUserFilter = _ref.showUserFilter,
    portal = _ref.portal,
    session = _ref.session,
    addUser = _ref.addUser,
    queryResults = _ref.queryResults,
    getUserFolders = _ref.getUserFolders,
    other = _objectWithoutProperties(_ref, ["itemBrowserState", "handleStateUpdate", "showFolderFilter", "showUserFilter", "portal", "session", "addUser", "queryResults", "getUserFolders"]);
  var filters = itemBrowserState.filters,
    folders = itemBrowserState.folders,
    users = itemBrowserState.users;
  var onChangeFilter = function onChangeFilter(newFilter) {
    handleStateUpdate(_objectSpread(_objectSpread({}, itemBrowserState), {}, {
      filters: newFilter
    }));
  };
  var onChangeUser = (0, _react.useCallback)(function (newUsers, username) {
    handleStateUpdate(_objectSpread(_objectSpread({}, itemBrowserState), {}, {
      users: newUsers
    }), username);
  }, [itemBrowserState, handleStateUpdate]);
  var onUserItemClick = function onUserItemClick(id) {
    _actions.default.onClickUserItem({
      id: id,
      itemState: _stateTypes.default.USER_ITEM_ACTIVE,
      users: users,
      onChangeUser: onChangeUser
    });
  };
  var onChangeFolder = (0, _react.useCallback)(function (newFolders) {
    handleStateUpdate(_objectSpread(_objectSpread({}, itemBrowserState), {}, {
      folders: newFolders
    }));
  }, [itemBrowserState, handleStateUpdate]);
  var onFolderItemClick = function onFolderItemClick(id) {
    if (folders.items.byId[id].state === _stateTypes.default.FOLDER_ITEM_DEFAULT) {
      _actions.default.onClickFolderItem({
        id: id,
        itemState: _stateTypes.default.FOLDER_ITEM_ACTIVE,
        folders: folders,
        onChangeFolder: onChangeFolder
      });
    }
  };
  var onFilterItemClick = function onFilterItemClick(id) {
    _actions.default.onClickItem({
      id: id,
      itemState: filters.items.byId[id].state === _stateTypes.default.FILTER_ITEM_ACTIVE ? _stateTypes.default.FILTER_ITEM_DEFAULT : _stateTypes.default.FILTER_ITEM_ACTIVE,
      filters: filters,
      onChangeFilter: onChangeFilter
    });
  };
  var onFilterItemOptionClick = function onFilterItemOptionClick(id) {
    _actions.default.onClickItemOption({
      id: id,
      itemOptionState: filters.itemOptions.byId[id].state === _stateTypes.default.FILTER_ITEM_OPTION_ACTIVE ? _stateTypes.default.FILTER_ITEM_OPTION_DEFAULT : _stateTypes.default.FILTER_ITEM_OPTION_ACTIVE,
      filters: filters,
      onChangeFilter: onChangeFilter
    });
  };
  return /*#__PURE__*/_react.default.createElement(_ItemFilterStyled.StyledItemFilter, other, (portal === null || portal === void 0 ? void 0 : (_portal$user = portal.user) === null || _portal$user === void 0 ? void 0 : (_portal$user$privileg = _portal$user.privileges) === null || _portal$user$privileg === void 0 ? void 0 : _portal$user$privileg.includes("portal:admin:updateItems")) && showUserFilter && /*#__PURE__*/_react.default.createElement(_Users.default, {
    users: users,
    userSession: session,
    onUserItemClick: onUserItemClick,
    addUser: addUser,
    portal: portal,
    marginBottom: true
  }), showFolderFilter && /*#__PURE__*/_react.default.createElement(_Folders.default, {
    folders: folders,
    userSession: session,
    onFolderItemClick: onFolderItemClick,
    marginBottom: true,
    queryResults: queryResults,
    getUserFolders: getUserFolders,
    allowCreateNewFolder: true
  }), /*#__PURE__*/_react.default.createElement(_Filters.default, {
    filters: filters,
    onChangeFilter: onChangeFilter,
    onFilterItemClick: onFilterItemClick,
    onFilterItemOptionClick: onFilterItemOptionClick
  }));
};
ItemFilter.propTypes = {
  itemBrowserState: _propTypes.default.object.isRequired,
  handleStateUpdate: _propTypes.default.func,
  session: _propTypes.default.object
};
var _default = ItemFilter;
exports.default = _default;